import React from 'react';
import FieldError from './parts/FieldError';
import styled from '@emotion/styled';
import { colors } from '../../../core/styles/theme/default';
import { rem } from 'polished';
import i18n from '../measure-i18n';

const StyledCheckbox = styled.label`
  display: inline-flex;
  align-items: flex-start;
  font-size: ${rem(14)};
  gap: ${rem(8)};

  input {
    cursor: pointer;
    appearance: none;
    position: relative;
    min-height: 0;
    padding: 0;
    margin: ${rem(-2)} 0 0;
    height: ${rem(24)};
    width: ${rem(24)};
    flex-shrink: 0;

    &:checked:after {
      content: '✔';
      position: absolute;
      top: ${rem(2)};
      left: ${rem(3)};
      font-size: ${rem(18)};
      color: ${colors.grue800};
    }
  }

  a {
    text-decoration: underline;
    text-underline-offset: ${rem(4)};
  }
`;

const Checkbox = ({
  id,
  label,
  locale,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  placeholder,
  isRequired,
  isDisabled,
  errorRenderer,
}: CheckboxType) => {
  return (
    <div>
      <StyledCheckbox>
        <input
          name={id}
          id={id}
          checked={!!value}
          placeholder={placeholder}
          type={'checkbox'}
          disabled={!!isDisabled}
          aria-required={!!isRequired}
          data-error={!!error}
          onChange={(e) => {
            if (typeof onChange === 'function') onChange(e.target.checked);
          }}
          onFocus={() => {
            if (typeof onFocus === 'function') onFocus();
          }}
          onBlur={() => {
            if (typeof onBlur === 'function') onBlur();
          }}
        />
        <span dangerouslySetInnerHTML={{ __html: label }} />
      </StyledCheckbox>
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <FieldError text={i18n.requiredField[locale]} />
        )
      ) : null}
    </div>
  );
};

export const isValid = (value: any, config: any) => {
  if (config.isRequired && (value === '' || typeof value === 'undefined'))
    return false;
  return true;
};

export type CheckboxType = {
  id: string;
  label: string;
  locale: string;
  value: string;
  onChange: (value: boolean) => void;
  onBlur: () => void;
  onFocus: () => void;
  error: string;
  placeholder: string;
  isRequired: boolean;
  isDisabled: boolean;
  prefix: string;
  suffix: string;
  type: string;
  errorRenderer: (error: string) => JSX.Element;
};

export default Checkbox;
